export default __webpack_public_path__ + "static/media/fm.e238c9fb.svg";